/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchUserMasters = /* GraphQL */ `
  query SearchUserMasters(
    $filter: SearchableUserMasterFilterInput
    $sort: [SearchableUserMasterSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserMasterAggregationInput]
  ) {
    searchUserMasters(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          items{
            about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
          }
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchUserProfileDetails = /* GraphQL */ `
  query SearchUserProfileDetails(
    $filter: SearchableUserProfileDetailsFilterInput
    $sort: [SearchableUserProfileDetailsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserProfileDetailsAggregationInput]
  ) {
    searchUserProfileDetails(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        isGroupSchoolAdmin
        isSchoolAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        userSystemAccessRole
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchCards = /* GraphQL */ `
  query SearchCards(
    $filter: SearchableCardFilterInput
    $sort: [SearchableCardSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCardAggregationInput]
  ) {
    searchCards(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchCardItems = /* GraphQL */ `
  query SearchCardItems(
    $filter: SearchableCardItemsFilterInput
    $sort: [SearchableCardItemsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCardItemsAggregationInput]
  ) {
    searchCardItems(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        cardID
        data
        newdata
        id
        restricted
        status
        schoolName
        currentStuding
        companyName
        currentlyWorking
        issuingOrganisation
        accomplishmentsProvider
        membershipOrganisation
        courseName
        branchName
        batchName
        referralCode
        location
        userCardItemsID {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        createdAt
        updatedAt
        cardUserCardItemssId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInterestUsers = /* GraphQL */ `
  query SearchInterestUsers(
    $filter: SearchableInterestUserFilterInput
    $sort: [SearchableInterestUserSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInterestUserAggregationInput]
  ) {
    searchInterestUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userInterestID
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        user {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsInterestsId
        interestUsersId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchSubinterestUsers = /* GraphQL */ `
  query SearchSubinterestUsers(
    $filter: SearchableSubinterestUserFilterInput
    $sort: [SearchableSubinterestUserSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSubinterestUserAggregationInput]
  ) {
    searchSubinterestUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userInterestID
        subinterestID
        user {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        subinterest {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsSubinterestsId
        subinterestUsersId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchQuizDetails = /* GraphQL */ `
  query SearchQuizDetails(
    $filter: SearchableQuizDetailsFilterInput
    $sort: [SearchableQuizDetailsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableQuizDetailsAggregationInput]
  ) {
    searchQuizDetails(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchQuizQuestions = /* GraphQL */ `
  query SearchQuizQuestions(
    $filter: SearchableQuizQuestionsFilterInput
    $sort: [SearchableQuizQuestionsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableQuizQuestionsAggregationInput]
  ) {
    searchQuizQuestions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchQuizInstances = /* GraphQL */ `
  query SearchQuizInstances(
    $filter: SearchableQuizInstanceFilterInput
    $sort: [SearchableQuizInstanceSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableQuizInstanceAggregationInput]
  ) {
    searchQuizInstances(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchQuizStudents = /* GraphQL */ `
  query SearchQuizStudents(
    $filter: SearchableQuizStudentFilterInput
    $sort: [SearchableQuizStudentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableQuizStudentAggregationInput]
  ) {
    searchQuizStudents(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        isParticipating
        userId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsQuizStudentId
        quizInstanceQuizInstanceStudentsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchQuizStudentQuestionResults = /* GraphQL */ `
  query SearchQuizStudentQuestionResults(
    $filter: SearchableQuizStudentQuestionResultFilterInput
    $sort: [SearchableQuizStudentQuestionResultSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableQuizStudentQuestionResultAggregationInput]
  ) {
    searchQuizStudentQuestionResults(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        userId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        answerReceived
        pointsEarned
        createdAt
        updatedAt
        userProfileDetailsQuizStudentQuestionResultId
        quizQuestionsQuizStudentQuestionResultId
        quizInstanceQuizStudentQuestionResultId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchModuleStudentQuestionResults = /* GraphQL */ `
  query SearchModuleStudentQuestionResults(
    $filter: SearchableModuleStudentQuestionResultFilterInput
    $sort: [SearchableModuleStudentQuestionResultSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableModuleStudentQuestionResultAggregationInput]
  ) {
    searchModuleStudentQuestionResults(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        moduleUserId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        postId {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        iSpringID
        moduleCategory
        moduleLevel
        moduleTitle
        moduleGrade
        moduleSeqNo
        questionIndex
        questionText
        totalScore
        schoolName
        schoolLocation
        userAnswer
        creatorEmail
        Status
        correctAnswer
        pointsAllotted
        pointsEarned
        createdAt
        updatedAt
        userProfileDetailsModuleStudentQuestionResultId
        postsStudentModuleQuestionResultId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInteractiveQuizDetails = /* GraphQL */ `
  query SearchInteractiveQuizDetails(
    $filter: SearchableInteractiveQuizDetailsFilterInput
    $sort: [SearchableInteractiveQuizDetailsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInteractiveQuizDetailsAggregationInput]
  ) {
    searchInteractiveQuizDetails(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInteractiveQuizQuestions = /* GraphQL */ `
  query SearchInteractiveQuizQuestions(
    $filter: SearchableInteractiveQuizQuestionsFilterInput
    $sort: [SearchableInteractiveQuizQuestionsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInteractiveQuizQuestionsAggregationInput]
  ) {
    searchInteractiveQuizQuestions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInteractiveQuizInstances = /* GraphQL */ `
  query SearchInteractiveQuizInstances(
    $filter: SearchableInteractiveQuizInstanceFilterInput
    $sort: [SearchableInteractiveQuizInstanceSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInteractiveQuizInstanceAggregationInput]
  ) {
    searchInteractiveQuizInstances(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInteractiveQuizStudents = /* GraphQL */ `
  query SearchInteractiveQuizStudents(
    $filter: SearchableInteractiveQuizStudentFilterInput
    $sort: [SearchableInteractiveQuizStudentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInteractiveQuizStudentAggregationInput]
  ) {
    searchInteractiveQuizStudents(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        isParticipating
        userId {
          id
          first_name
          last_name
          mobile_no
          userType
          username
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizUserProfileDetailsQuizStudentId
        interactiveQuizInstanceQuizInstanceStudentsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchInteractiveQuizStudentQuestionResults = /* GraphQL */ `
  query SearchInteractiveQuizStudentQuestionResults(
    $filter: SearchableInteractiveQuizStudentQuestionResultFilterInput
    $sort: [SearchableInteractiveQuizStudentQuestionResultSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInteractiveQuizStudentQuestionResultAggregationInput]
  ) {
    searchInteractiveQuizStudentQuestionResults(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        userId {
          id
          first_name
          last_name
          mobile_no
          userType
          username
          createdAt
          updatedAt
          __typename
        }
        answerReceived
        pointsEarned
        createdAt
        updatedAt
        interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
        interactiveQuizQuestionsQuizStudentQuestionResultId
        interactiveQuizInstanceQuizStudentQuestionResultId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserMaster = /* GraphQL */ `
  query GetUserMaster($id: ID!) {
    getUserMaster(id: $id) {
      email
      id
      isParent
      showPopup
      registerBy
      password
      status
      myfeedTour
      profileTour
      cvTour
      projectTour
      disabled
      registeredDate
      UserProfileDetails {
        items {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        nextToken
        __typename
      }
      auth_method
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserMasters = /* GraphQL */ `
  query ListUserMasters(
    $filter: ModelUserMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProfileDetails = /* GraphQL */ `
  query GetUserProfileDetails($id: ID!) {
    getUserProfileDetails(id: $id) {
      userID {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      about_me
      about_restriction
      bg_image
      career_goal
      city
      cnt_views
      cv_data
      country
      cvs
      dob
      first_name
      gender
      id
      job
      languages
      last_name
      links
      loginAt
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      profile_avatar
      profile_complition
      profile_image
      projects
      projects_data
      referralCode
      school_name
      accomplishment_data
      connection_data
      skipMobileVerification
      skipParentalconsent
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isparentRequestSent
      mobileSmsTriggerCnt
      selfEmailTriggerCnt
      parentRequestSentTriggerCnt
      welcomeEmailSentCnt
      mobileSmsTriggerDt
      selfEmailTriggerDt
      parentRequestSentTriggerDt
      welcomeEmailSentDt
      mobileReminderSmsTriggerCnt
      mobileReminderSmsTriggerDt
      mobileCountrycode
      parentmobileCountrycode
      isTestUser
      source
      isAdmin
      isGroupSchoolAdmin
      isSchoolAdmin
      adminSchoolName
      adminCompanyName
      adminIssuingOrganisation
      adminAccomplishmentsProvider
      adminMembershipOrganisation
      adminLogo
      state
      tblrolemappingID
      userProfileDetailsUserMasterId
      userType
      username
      UserCards {
        items {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        nextToken
        __typename
      }
      UserCvs {
        items {
          cv_title
          description
          id
          link
          password
          restricted
          status
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCvsId
          __typename
        }
        nextToken
        __typename
      }
      connections {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          action
          content
          delete
          read
          subject
          turnoffsimilar
          createdAt
          updatedAt
          userProfileDetailsNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      userActivity {
        items {
          id
          cartItem_id
          status
          type
          data
          createdAt
          updatedAt
          userProfileDetailsUserActivityId
          __typename
        }
        nextToken
        __typename
      }
      posts {
        items {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      CommentOne {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      registeredDate
      adminSchoolType
      quizAvgScore
      interests {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      subinterests {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      moduleStudentQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      connectedInstituteAdmins
      connectionsCount
      portfolioCount
      blogCount
      diaryCount
      cvCount
      mystuffCount
      createdAt
      updatedAt
      userMasterUserProfileDetailsId
      userSystemAccessRole
      __typename
    }
  }
`;
export const listUserProfileDetails = /* GraphQL */ `
  query ListUserProfileDetails(
    $filter: ModelUserProfileDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfileDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        userSystemAccessRole
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCard = /* GraphQL */ `
  query GetCard($id: ID!) {
    getCard(id: $id) {
      id
      restricted
      status
      title
      type
      userprofiledetailsID
      userCardID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      UserCardItemss {
        items {
          cardID
          data
          newdata
          id
          restricted
          status
          schoolName
          currentStuding
          companyName
          currentlyWorking
          issuingOrganisation
          accomplishmentsProvider
          membershipOrganisation
          courseName
          branchName
          batchName
          referralCode
          location
          createdAt
          updatedAt
          cardUserCardItemssId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCardsId
      __typename
    }
  }
`;
export const listCards = /* GraphQL */ `
  query ListCards(
    $filter: ModelCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCardItems = /* GraphQL */ `
  query GetCardItems($id: ID!) {
    getCardItems(id: $id) {
      cardID
      data
      newdata
      id
      restricted
      status
      schoolName
      currentStuding
      companyName
      currentlyWorking
      issuingOrganisation
      accomplishmentsProvider
      membershipOrganisation
      courseName
      branchName
      batchName
      referralCode
      location
      userCardItemsID {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      createdAt
      updatedAt
      cardUserCardItemssId
      __typename
    }
  }
`;
export const listCardItems = /* GraphQL */ `
  query ListCardItems(
    $filter: ModelCardItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCardItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        cardID
        data
        newdata
        id
        restricted
        status
        schoolName
        currentStuding
        companyName
        currentlyWorking
        issuingOrganisation
        accomplishmentsProvider
        membershipOrganisation
        courseName
        branchName
        batchName
        referralCode
        location
        userCardItemsID {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        createdAt
        updatedAt
        cardUserCardItemssId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventMaster = /* GraphQL */ `
  query GetEventMaster($id: ID!) {
    getEventMaster(id: $id) {
      event_module
      event_name
      event_sub_module
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEventMasters = /* GraphQL */ `
  query ListEventMasters(
    $filter: ModelEventMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        event_module
        event_name
        event_sub_module
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventTransactions = /* GraphQL */ `
  query GetEventTransactions($id: ID!) {
    getEventTransactions(id: $id) {
      action_done_by_user_id
      createdAt
      entity_id
      entity_owner_user_id
      id
      payload_after
      payload_before
      userBrowser
      userOS
      userDevice
      userIP
      userReferrer
      registrationType
      interests
      status
      updatedAt
      __typename
    }
  }
`;
export const listEventTransactions = /* GraphQL */ `
  query ListEventTransactions(
    $filter: ModelEventTransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        action_done_by_user_id
        createdAt
        entity_id
        entity_owner_user_id
        id
        payload_after
        payload_before
        userBrowser
        userOS
        userDevice
        userIP
        userReferrer
        registrationType
        interests
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServicesLogs = /* GraphQL */ `
  query GetServicesLogs($id: ID!) {
    getServicesLogs(id: $id) {
      createdAt
      id
      module
      request
      response
      status
      type
      updatedAt
      __typename
    }
  }
`;
export const listServicesLogs = /* GraphQL */ `
  query ListServicesLogs(
    $filter: ModelServicesLogsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServicesLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        module
        request
        response
        status
        type
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSettings = /* GraphQL */ `
  query GetSettings($id: ID!) {
    getSettings(id: $id) {
      id
      module
      setting
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSettings = /* GraphQL */ `
  query ListSettings(
    $filter: ModelSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        module
        setting
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblBadgeDetails = /* GraphQL */ `
  query GetTblBadgeDetails($id: ID!) {
    getTblBadgeDetails(id: $id) {
      id
      issue_date
      restricted
      school_name
      status
      tblbadgemasterID
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblBadgeDetails = /* GraphQL */ `
  query ListTblBadgeDetails(
    $filter: ModelTblBadgeDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblBadgeDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        issue_date
        restricted
        school_name
        status
        tblbadgemasterID
        userprofiledetailsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblBadgeMaster = /* GraphQL */ `
  query GetTblBadgeMaster($id: ID!) {
    getTblBadgeMaster(id: $id) {
      badge_image
      badge_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblBadgeMasters = /* GraphQL */ `
  query ListTblBadgeMasters(
    $filter: ModelTblBadgeMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblBadgeMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        badge_image
        badge_name
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblCVDetails = /* GraphQL */ `
  query GetTblCVDetails($id: ID!) {
    getTblCVDetails(id: $id) {
      cv_title
      description
      id
      link
      password
      restricted
      status
      userprofiledetailsID
      usercvID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCvsId
      __typename
    }
  }
`;
export const listTblCVDetails = /* GraphQL */ `
  query ListTblCVDetails(
    $filter: ModelTblCVDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblCVDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        cv_title
        description
        id
        link
        password
        restricted
        status
        userprofiledetailsID
        usercvID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCvsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblCourse = /* GraphQL */ `
  query GetTblCourse($id: ID!) {
    getTblCourse(id: $id) {
      course_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblCourses = /* GraphQL */ `
  query ListTblCourses(
    $filter: ModelTblCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        course_name
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblEmployees = /* GraphQL */ `
  query GetTblEmployees($id: ID!) {
    getTblEmployees(id: $id) {
      employment_type
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblEmployees = /* GraphQL */ `
  query ListTblEmployees(
    $filter: ModelTblEmployeesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        employment_type
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblGradeMaster = /* GraphQL */ `
  query GetTblGradeMaster($id: ID!) {
    getTblGradeMaster(id: $id) {
      grade_name
      id
      series
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblGradeMasters = /* GraphQL */ `
  query ListTblGradeMasters(
    $filter: ModelTblGradeMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblGradeMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        grade_name
        id
        series
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblHobbiesMaster = /* GraphQL */ `
  query GetTblHobbiesMaster($id: ID!) {
    getTblHobbiesMaster(id: $id) {
      hobbies_image
      hobbies_name
      id
      status
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblHobbiesMasters = /* GraphQL */ `
  query ListTblHobbiesMasters(
    $filter: ModelTblHobbiesMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblHobbiesMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        hobbies_image
        hobbies_name
        id
        status
        userprofiledetailsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblIndustry = /* GraphQL */ `
  query GetTblIndustry($id: ID!) {
    getTblIndustry(id: $id) {
      id
      industry_name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblIndustries = /* GraphQL */ `
  query ListTblIndustries(
    $filter: ModelTblIndustryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblIndustries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        industry_name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblLang = /* GraphQL */ `
  query GetTblLang($id: ID!) {
    getTblLang(id: $id) {
      Language_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblLangs = /* GraphQL */ `
  query ListTblLangs(
    $filter: ModelTblLangFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblLangs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        Language_name
        id
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblOtpEmail = /* GraphQL */ `
  query GetTblOtpEmail($id: ID!) {
    getTblOtpEmail(id: $id) {
      email
      id
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblOtpEmails = /* GraphQL */ `
  query ListTblOtpEmails(
    $filter: ModelTblOtpEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblOtpEmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        email
        id
        otp
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblOtpMobile = /* GraphQL */ `
  query GetTblOtpMobile($id: ID!) {
    getTblOtpMobile(id: $id) {
      id
      mobile_no
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblOtpMobiles = /* GraphQL */ `
  query ListTblOtpMobiles(
    $filter: ModelTblOtpMobileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblOtpMobiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobile_no
        otp
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblPortfolioProjectSubjects = /* GraphQL */ `
  query GetTblPortfolioProjectSubjects($id: ID!) {
    getTblPortfolioProjectSubjects(id: $id) {
      id
      status
      subject_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblPortfolioProjectSubjects = /* GraphQL */ `
  query ListTblPortfolioProjectSubjects(
    $filter: ModelTblPortfolioProjectSubjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblPortfolioProjectSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        subject_name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTblSkillsMaster = /* GraphQL */ `
  query GetTblSkillsMaster($id: ID!) {
    getTblSkillsMaster(id: $id) {
      id
      skill_name
      skill_type
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTblSkillsMasters = /* GraphQL */ `
  query ListTblSkillsMasters(
    $filter: ModelTblSkillsMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblSkillsMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        skill_name
        skill_type
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMyIndTable = /* GraphQL */ `
  query GetMyIndTable($id: ID!) {
    getMyIndTable(id: $id) {
      content
      id
      price
      rating
      title
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMyIndTables = /* GraphQL */ `
  query ListMyIndTables(
    $filter: ModelMyIndTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMyIndTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        content
        id
        price
        rating
        title
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTmpUserDetails = /* GraphQL */ `
  query GetTmpUserDetails($id: ID!) {
    getTmpUserDetails(id: $id) {
      city
      country
      dob
      email
      first_name
      gender
      id
      job
      last_name
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      referralCode
      state
      status
      userType
      username
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTmpUserDetails = /* GraphQL */ `
  query ListTmpUserDetails(
    $filter: ModelTmpUserDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTmpUserDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        city
        country
        dob
        email
        first_name
        gender
        id
        job
        last_name
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        referralCode
        state
        status
        userType
        username
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConnection = /* GraphQL */ `
  query GetConnection($id: ID!) {
    getConnection(id: $id) {
      id
      tag
      users {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tags {
        id
        tag_name
        type
        tagConnect {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tagMasterTagConnectId
      __typename
    }
  }
`;
export const listConnections = /* GraphQL */ `
  query ListConnections(
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnections(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tag
        users {
          nextToken
          __typename
        }
        tags {
          id
          tag_name
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tagMasterTagConnectId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFriendRequest = /* GraphQL */ `
  query GetFriendRequest($id: ID!) {
    getFriendRequest(id: $id) {
      id
      from_user_id
      to_user_id
      status
      accept_date
      decline_date
      connectionFriendID
      isAdminTriggered
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFriendRequests = /* GraphQL */ `
  query ListFriendRequests(
    $filter: ModelFriendRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFriendRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        from_user_id
        to_user_id
        status
        accept_date
        decline_date
        connectionFriendID
        isAdminTriggered
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchFriendRequests = /* GraphQL */ `
  query SearchFriendRequests(
    $filter: SearchableFriendRequestFilterInput
    $sort: [SearchableFriendRequestSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableFriendRequestAggregationInput]
  ) {
    searchFriendRequests(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        from_user_id
        to_user_id
        status
        accept_date
        decline_date
        connectionFriendID
        isAdminTriggered
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getTagMaster = /* GraphQL */ `
  query GetTagMaster($id: ID!) {
    getTagMaster(id: $id) {
      id
      tag_name
      type
      tagConnect {
        items {
          id
          tag
          createdAt
          updatedAt
          tagMasterTagConnectId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTagMasters = /* GraphQL */ `
  query ListTagMasters(
    $filter: ModelTagMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTagMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tag_name
        type
        tagConnect {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCountries = /* GraphQL */ `
  query GetCountries($id: ID!) {
    getCountries(id: $id) {
      id
      name
      iso3
      iso2
      numeric_code
      phone_code
      capital
      currency
      currency_name
      currency_symbol
      native
      region
      subregion
      latitude
      longitude
      emoji
      emojiU
      states {
        items {
          id
          name
          state_code
          latitude
          longitude
          createdAt
          updatedAt
          countriesStatesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCountries = /* GraphQL */ `
  query ListCountries(
    $filter: ModelCountriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCountries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        iso3
        iso2
        numeric_code
        phone_code
        capital
        currency
        currency_name
        currency_symbol
        native
        region
        subregion
        latitude
        longitude
        emoji
        emojiU
        states {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStates = /* GraphQL */ `
  query GetStates($id: ID!) {
    getStates(id: $id) {
      id
      name
      state_code
      latitude
      longitude
      cities {
        items {
          id
          name
          latitude
          longitude
          createdAt
          updatedAt
          statesCitiesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      countriesStatesId
      __typename
    }
  }
`;
export const listStates = /* GraphQL */ `
  query ListStates(
    $filter: ModelStatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        state_code
        latitude
        longitude
        cities {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        countriesStatesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCities = /* GraphQL */ `
  query GetCities($id: ID!) {
    getCities(id: $id) {
      id
      name
      latitude
      longitude
      createdAt
      updatedAt
      statesCitiesId
      __typename
    }
  }
`;
export const listCities = /* GraphQL */ `
  query ListCities(
    $filter: ModelCitiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        latitude
        longitude
        createdAt
        updatedAt
        statesCitiesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpamReports = /* GraphQL */ `
  query GetSpamReports($id: ID!) {
    getSpamReports(id: $id) {
      id
      reportTo
      reportToName
      reportToEmail
      reportFrom
      reportFromName
      reportFromEmail
      reportedItemType
      reportedPost
      isActionTaken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpamReports = /* GraphQL */ `
  query ListSpamReports(
    $filter: ModelSpamReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpamReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reportTo
        reportToName
        reportToEmail
        reportFrom
        reportFromName
        reportFromEmail
        reportedItemType
        reportedPost
        isActionTaken
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchSpamReports = /* GraphQL */ `
  query SearchSpamReports(
    $filter: SearchableSpamReportsFilterInput
    $sort: [SearchableSpamReportsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSpamReportsAggregationInput]
  ) {
    searchSpamReports(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        reportTo
        reportToName
        reportToEmail
        reportFrom
        reportFromName
        reportFromEmail
        reportedItemType
        reportedPost
        isActionTaken
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getInviteConnections = /* GraphQL */ `
  query GetInviteConnections($id: ID!) {
    getInviteConnections(id: $id) {
      id
      senderUserId
      senderUserEmail
      senderUserName
      toEmail
      toName
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInviteConnections = /* GraphQL */ `
  query ListInviteConnections(
    $filter: ModelInviteConnectionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInviteConnections(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserId
        senderUserEmail
        senderUserName
        toEmail
        toName
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotifications = /* GraphQL */ `
  query GetNotifications($id: ID!) {
    getNotifications(id: $id) {
      id
      action
      content
      delete
      read
      subject
      turnoffsimilar
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsNotificationsId
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        action
        content
        delete
        read
        subject
        turnoffsimilar
        userId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsNotificationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotificationsRules = /* GraphQL */ `
  query GetNotificationsRules($id: ID!) {
    getNotificationsRules(id: $id) {
      id
      category
      subcategory
      subject
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotificationsRules = /* GraphQL */ `
  query ListNotificationsRules(
    $filter: ModelNotificationsRulesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationsRules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        subcategory
        subject
        templates
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserActivity = /* GraphQL */ `
  query GetUserActivity($id: ID!) {
    getUserActivity(id: $id) {
      id
      from_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      to_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      cartItem_id
      status
      type
      data
      createdAt
      updatedAt
      userProfileDetailsUserActivityId
      __typename
    }
  }
`;
export const listUserActivities = /* GraphQL */ `
  query ListUserActivities(
    $filter: ModelUserActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        from_user_id {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          connectionsCount
          portfolioCount
          blogCount
          diaryCount
          cvCount
          mystuffCount
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        to_user_id {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          connectionsCount
          portfolioCount
          blogCount
          diaryCount
          cvCount
          mystuffCount
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        cartItem_id
        status
        type
        data
        createdAt
        updatedAt
        userProfileDetailsUserActivityId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPosts = /* GraphQL */ `
  query GetPosts($id: ID!) {
    getPosts(id: $id) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      postUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      rootPostId
      refrencePostId
      cardItemID
      postType
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      studentModuleQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsPostsId
      __typename
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $filter: ModelPostsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchPosts = /* GraphQL */ `
  query SearchPosts(
    $filter: SearchablePostsFilterInput
    $sort: [SearchablePostsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchablePostsAggregationInput]
  ) {
    searchPosts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          items {
            id
            ipAddress
            status
            createdAt
            updatedAt
            userProfileDetailsViewsId
            postsViewsId
          }
          nextToken
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getComments = /* GraphQL */ `
  query GetComments($id: ID!) {
    getComments(id: $id) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentsId
      postsCommentsId
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        comments {
          items {
            commentsCommentsId
            createdAt
            id
            message
            updatedAt
            userProfileDetailsCommentOneId
            commentUserID {
              about_me
              about_restriction
              bg_image
              career_goal
              city
              cnt_views
              cv_data
              country
              cvs
              dob
              first_name
              gender
              id
              job
              languages
              last_name
              links
              loginAt
              middle_name
              mobile_no
              parent_email
              parent_mobile
              parent_name
              profile_avatar
              profile_complition
              profile_image
              projects
              projects_data
              referralCode
              school_name
              accomplishment_data
              connection_data
              skipMobileVerification
              skipParentalconsent
              isMobileVerified
              isParentVerified
              isSelfEmailVerified
              isparentRequestSent
              mobileSmsTriggerCnt
              selfEmailTriggerCnt
              parentRequestSentTriggerCnt
              welcomeEmailSentCnt
              mobileSmsTriggerDt
              selfEmailTriggerDt
              parentRequestSentTriggerDt
              welcomeEmailSentDt
              mobileReminderSmsTriggerCnt
              mobileReminderSmsTriggerDt
              mobileCountrycode
              parentmobileCountrycode
              isTestUser
              source
              isAdmin
              adminSchoolName
              adminCompanyName
              adminIssuingOrganisation
              adminAccomplishmentsProvider
              adminMembershipOrganisation
              adminLogo
              state
              tblrolemappingID
              userProfileDetailsUserMasterId
              userType
              username
              registeredDate
              adminSchoolType
              quizAvgScore
              connectedInstituteAdmins
              createdAt
              updatedAt
              userMasterUserProfileDetailsId
              __typename
            }
          }
          nextToken
          __typename
        }
        commentUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        message
        createdAt
        updatedAt
        userProfileDetailsCommentsId
        postsCommentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchComments = /* GraphQL */ `
  query SearchComments(
    $filter: SearchableCommentsFilterInput
    $sort: [SearchableCommentsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCommentsAggregationInput]
  ) {
    searchComments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        message
        createdAt
        updatedAt
        userProfileDetailsCommentsId
        postsCommentsId
        commentUserID {
          first_name
          gender
          id
          last_name
          middle_name
          school_name
          username
          userMasterUserProfileDetailsId
          __typename
        }
        comments {
          items {
            commentsCommentsId
            createdAt
            id
            message
            updatedAt
            userProfileDetailsCommentOneId
            commentUserID {
              first_name
              gender
              id
              last_name
              middle_name
              school_name
              username
              userMasterUserProfileDetailsId
              __typename
            }
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCommentOne = /* GraphQL */ `
  query GetCommentOne($id: ID!) {
    getCommentOne(id: $id) {
      id
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentOneId
      commentsCommentsId
      __typename
    }
  }
`;
export const listCommentOnes = /* GraphQL */ `
  query ListCommentOnes(
    $filter: ModelCommentOneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommentOnes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        commentUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        message
        createdAt
        updatedAt
        userProfileDetailsCommentOneId
        commentsCommentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCommentOnes = /* GraphQL */ `
  query SearchCommentOnes(
    $filter: SearchableCommentOneFilterInput
    $sort: [SearchableCommentOneSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCommentOneAggregationInput]
  ) {
    searchCommentOnes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        message
        createdAt
        updatedAt
        userProfileDetailsCommentOneId
        commentsCommentsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getLikes = /* GraphQL */ `
  query GetLikes($id: ID!) {
    getLikes(id: $id) {
      id
      likeUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      status
      createdAt
      updatedAt
      userProfileDetailsLikesId
      postsLikesId
      __typename
    }
  }
`;
export const listLikes = /* GraphQL */ `
  query ListLikes(
    $filter: ModelLikesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        likeUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        status
        createdAt
        updatedAt
        userProfileDetailsLikesId
        postsLikesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchLikes = /* GraphQL */ `
  query SearchLikes(
    $filter: SearchableLikesFilterInput
    $sort: [SearchableLikesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableLikesAggregationInput]
  ) {
    searchLikes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        status
        createdAt
        updatedAt
        userProfileDetailsLikesId
        postsLikesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPostViews = /* GraphQL */ `
  query GetPostViews($id: ID!) {
    getPostViews(id: $id) {
      id
      viewUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      ipAddress
      status
      createdAt
      updatedAt
      userProfileDetailsViewsId
      postsViewsId
      __typename
    }
  }
`;
export const listPostViews = /* GraphQL */ `
  query ListPostViews(
    $filter: ModelPostViewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPostViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        viewUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        ipAddress
        status
        createdAt
        updatedAt
        userProfileDetailsViewsId
        postsViewsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchPostViews = /* GraphQL */ `
  query SearchPostViews(
    $filter: SearchablePostViewsFilterInput
    $sort: [SearchablePostViewsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchablePostViewsAggregationInput]
  ) {
    searchPostViews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        ipAddress
        status
        createdAt
        updatedAt
        userProfileDetailsViewsId
        postsViewsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getQuizResults = /* GraphQL */ `
  query GetQuizResults($id: ID!) {
    getQuizResults(id: $id) {
      id
      quizUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      iSpringID
      quizCategory
      quizLevel
      quizTitle
      quizGrade
      quizSeqNo
      totalScore
      quizScore
      status
      createdAt
      updatedAt
      userProfileDetailsQuizResultsId
      postsQuizResultsId
      __typename
    }
  }
`;
export const listQuizResults = /* GraphQL */ `
  query ListQuizResults(
    $filter: ModelQuizResultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizResults(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quizUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        iSpringID
        quizCategory
        quizLevel
        quizTitle
        quizGrade
        quizSeqNo
        totalScore
        quizScore
        status
        createdAt
        updatedAt
        userProfileDetailsQuizResultsId
        postsQuizResultsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategories = /* GraphQL */ `
  query GetCategories($id: ID!) {
    getCategories(id: $id) {
      id
      name
      slug
      status
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        status
        postCategories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPostCategories = /* GraphQL */ `
  query GetPostCategories($id: ID!) {
    getPostCategories(id: $id) {
      id
      postID {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      categoryID {
        id
        name
        slug
        status
        postCategories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      postsPostCategoriesId
      categoriesPostCategoriesId
      __typename
    }
  }
`;
export const listPostCategories = /* GraphQL */ `
  query ListPostCategories(
    $filter: ModelPostCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPostCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id

        postID {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          postUserID {
            id
            first_name
          }
          userProfileDetailsPostsId
          __typename
        }
        categoryID {
          id
          name
          slug
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        postsPostCategoriesId
        categoriesPostCategoriesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserAccessRole = /* GraphQL */ `
  query GetUserAccessRole($id: ID!) {
    getUserAccessRole(id: $id) {
      id
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isMinor
      isDisabled
      userStatus
      userStatusLabel
      priority
      canLogin
      canViewSelfProfile
      canViewOthersProfile
      canEditSelfProfile
      CanEditAccInfo
      canAddMentor
      canAddProjects
      canViewOtherProject
      canCreateCV
      canShareCV
      canViewOtherCV
      canMakeConnections
      canSearchConnections
      canAddDairy
      canEditDairy
      canDeleteDairy
      canAddBlog
      canEditBlog
      canDeleteBlog
      canViewBlog
      enableMobileVerification
      enableParentalVerification
      enableSelfEmailVerification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserAccessRoles = /* GraphQL */ `
  query ListUserAccessRoles(
    $filter: ModelUserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAccessRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInterest = /* GraphQL */ `
  query GetInterest($id: ID!) {
    getInterest(id: $id) {
      id
      name
      image
      subinterests {
        items {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        nextToken
        __typename
      }
      Users {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      orderBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInterests = /* GraphQL */ `
  query ListInterests(
    $filter: ModelInterestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubinterest = /* GraphQL */ `
  query GetSubinterest($id: ID!) {
    getSubinterest(id: $id) {
      id
      name
      image
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      Users {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interestSubinterestsId
      __typename
    }
  }
`;
export const listSubinterests = /* GraphQL */ `
  query ListSubinterests(
    $filter: ModelSubinterestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubinterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        image
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        Users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interestSubinterestsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInterestUser = /* GraphQL */ `
  query GetInterestUser($id: ID!) {
    getInterestUser(id: $id) {
      id
      userInterestID
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsInterestsId
      interestUsersId
      __typename
    }
  }
`;
export const listInterestUsers = /* GraphQL */ `
  query ListInterestUsers(
    $filter: ModelInterestUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInterestUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userInterestID
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        user {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsInterestsId
        interestUsersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubinterestUser = /* GraphQL */ `
  query GetSubinterestUser($id: ID!) {
    getSubinterestUser(id: $id) {
      id
      userInterestID
      subinterestID
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      subinterest {
        id
        name
        image
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        Users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interestSubinterestsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsSubinterestsId
      subinterestUsersId
      __typename
    }
  }
`;
export const listSubinterestUsers = /* GraphQL */ `
  query ListSubinterestUsers(
    $filter: ModelSubinterestUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubinterestUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userInterestID
        subinterestID
        user {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        subinterest {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsSubinterestsId
        subinterestUsersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDashboardSummary = /* GraphQL */ `
  query GetDashboardSummary($id: ID!) {
    getDashboardSummary(id: $id) {
      id
      totalUsers
      yesterdaysUsers
      totalProfile
      yesterdaysProfile
      totalProjects
      yesterdaysProjects
      totalCvs
      yesterdaysCvs
      totalConnections
      yesterdaysConnections
      totalAccomplishments
      yesterdaysAccomplishments
      totalSAccomplishments
      yesterdaysSAccomplishments
      totalLogins
      yesterdaysLogins
      totalUM
      totalUEMM
      totalFA
      totalPCM
      totalPMM
      totalUEM
      totalUMM
      totalDisabled
      perUM
      perUEMM
      perFA
      perPCM
      perPMM
      perUEM
      perUMM
      perDisabled
      totalUserInterests
      yesterdaysUserInterests
      totalUserSubInterests
      yesterdaysUserSubInterests
      totalInterestsUsers
      yesterdaysInterestsUsers
      totalCvsUser
      yesterdaysCvsUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDashboardSummaries = /* GraphQL */ `
  query ListDashboardSummaries(
    $filter: ModelDashboardSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboardSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalUsers
        yesterdaysUsers
        totalProfile
        yesterdaysProfile
        totalProjects
        yesterdaysProjects
        totalCvs
        yesterdaysCvs
        totalConnections
        yesterdaysConnections
        totalAccomplishments
        yesterdaysAccomplishments
        totalSAccomplishments
        yesterdaysSAccomplishments
        totalLogins
        yesterdaysLogins
        totalUM
        totalUEMM
        totalFA
        totalPCM
        totalPMM
        totalUEM
        totalUMM
        totalDisabled
        perUM
        perUEMM
        perFA
        perPCM
        perPMM
        perUEM
        perUMM
        perDisabled
        totalUserInterests
        yesterdaysUserInterests
        totalUserSubInterests
        yesterdaysUserSubInterests
        totalInterestsUsers
        yesterdaysInterestsUsers
        totalCvsUser
        yesterdaysCvsUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizDetails = /* GraphQL */ `
  query GetQuizDetails($id: ID!) {
    getQuizDetails(id: $id) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuizDetails = /* GraphQL */ `
  query ListQuizDetails(
    $filter: ModelQuizDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizQuestionOptions = /* GraphQL */ `
  query GetQuizQuestionOptions($id: ID!) {
    getQuizQuestionOptions(id: $id) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      quizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const listQuizQuestionOptions = /* GraphQL */ `
  query ListQuizQuestionOptions(
    $filter: ModelQuizQuestionOptionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizQuestionOptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        indexKey
        indexValue
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        createdAt
        updatedAt
        quizQuestionsQuizQuestionOptionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizQuestions = /* GraphQL */ `
  query GetQuizQuestions($id: ID!) {
    getQuizQuestions(id: $id) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          quizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      quizDetailsQuestionsId
      __typename
    }
  }
`;
export const listQuizQuestions = /* GraphQL */ `
  query ListQuizQuestions(
    $filter: ModelQuizQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizInstance = /* GraphQL */ `
  query GetQuizInstance($id: ID!) {
    getQuizInstance(id: $id) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      quizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const listQuizInstances = /* GraphQL */ `
  query ListQuizInstances(
    $filter: ModelQuizInstanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizInstances(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizStudent = /* GraphQL */ `
  query GetQuizStudent($id: ID!) {
    getQuizStudent(id: $id) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsQuizStudentId
      quizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const listQuizStudents = /* GraphQL */ `
  query ListQuizStudents(
    $filter: ModelQuizStudentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizStudents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        isParticipating
        userId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsQuizStudentId
        quizInstanceQuizInstanceStudentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuizStudentQuestionResult = /* GraphQL */ `
  query GetQuizStudentQuestionResult($id: ID!) {
    getQuizStudentQuestionResult(id: $id) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsQuizStudentQuestionResultId
      quizQuestionsQuizStudentQuestionResultId
      quizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const listQuizStudentQuestionResults = /* GraphQL */ `
  query ListQuizStudentQuestionResults(
    $filter: ModelQuizStudentQuestionResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizStudentQuestionResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        userId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        answerReceived
        pointsEarned
        createdAt
        updatedAt
        userProfileDetailsQuizStudentQuestionResultId
        quizQuestionsQuizStudentQuestionResultId
        quizInstanceQuizStudentQuestionResultId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getModuleStudentQuestionResult = /* GraphQL */ `
  query GetModuleStudentQuestionResult($id: ID!) {
    getModuleStudentQuestionResult(id: $id) {
      id
      moduleUserId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      postId {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      iSpringID
      moduleCategory
      moduleLevel
      moduleTitle
      moduleGrade
      moduleSeqNo
      questionIndex
      questionText
      totalScore
      schoolName
      schoolLocation
      userAnswer
      creatorEmail
      Status
      correctAnswer
      pointsAllotted
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsModuleStudentQuestionResultId
      postsStudentModuleQuestionResultId
      __typename
    }
  }
`;
export const listModuleStudentQuestionResults = /* GraphQL */ `
  query ListModuleStudentQuestionResults(
    $filter: ModelModuleStudentQuestionResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModuleStudentQuestionResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        moduleUserId {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        postId {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        iSpringID
        moduleCategory
        moduleLevel
        moduleTitle
        moduleGrade
        moduleSeqNo
        questionIndex
        questionText
        totalScore
        schoolName
        schoolLocation
        userAnswer
        creatorEmail
        Status
        correctAnswer
        pointsAllotted
        pointsEarned
        createdAt
        updatedAt
        userProfileDetailsModuleStudentQuestionResultId
        postsStudentModuleQuestionResultId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizUserProfileDetails = /* GraphQL */ `
  query GetInteractiveQuizUserProfileDetails($id: ID!) {
    getInteractiveQuizUserProfileDetails(id: $id) {
      id
      first_name
      last_name
      mobile_no
      userType
      username
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInteractiveQuizUserProfileDetails = /* GraphQL */ `
  query ListInteractiveQuizUserProfileDetails(
    $filter: ModelInteractiveQuizUserProfileDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizUserProfileDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizDetails = /* GraphQL */ `
  query GetInteractiveQuizDetails($id: ID!) {
    getInteractiveQuizDetails(id: $id) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInteractiveQuizDetails = /* GraphQL */ `
  query ListInteractiveQuizDetails(
    $filter: ModelInteractiveQuizDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizQuestionOptions = /* GraphQL */ `
  query GetInteractiveQuizQuestionOptions($id: ID!) {
    getInteractiveQuizQuestionOptions(id: $id) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const listInteractiveQuizQuestionOptions = /* GraphQL */ `
  query ListInteractiveQuizQuestionOptions(
    $filter: ModelInteractiveQuizQuestionOptionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizQuestionOptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        indexKey
        indexValue
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizQuestionsQuizQuestionOptionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizQuestions = /* GraphQL */ `
  query GetInteractiveQuizQuestions($id: ID!) {
    getInteractiveQuizQuestions(id: $id) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          interactiveQuizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizDetailsQuestionsId
      __typename
    }
  }
`;
export const listInteractiveQuizQuestions = /* GraphQL */ `
  query ListInteractiveQuizQuestions(
    $filter: ModelInteractiveQuizQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizInstance = /* GraphQL */ `
  query GetInteractiveQuizInstance($id: ID!) {
    getInteractiveQuizInstance(id: $id) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      interactiveQuizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const listInteractiveQuizInstances = /* GraphQL */ `
  query ListInteractiveQuizInstances(
    $filter: ModelInteractiveQuizInstanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizInstances(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizStudent = /* GraphQL */ `
  query GetInteractiveQuizStudent($id: ID!) {
    getInteractiveQuizStudent(id: $id) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentId
      interactiveQuizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const listInteractiveQuizStudents = /* GraphQL */ `
  query ListInteractiveQuizStudents(
    $filter: ModelInteractiveQuizStudentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizStudents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        isParticipating
        userId {
          id
          first_name
          last_name
          mobile_no
          userType
          username
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizUserProfileDetailsQuizStudentId
        interactiveQuizInstanceQuizInstanceStudentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractiveQuizStudentQuestionResult = /* GraphQL */ `
  query GetInteractiveQuizStudentQuestionResult($id: ID!) {
    getInteractiveQuizStudentQuestionResult(id: $id) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
      interactiveQuizQuestionsQuizStudentQuestionResultId
      interactiveQuizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const listInteractiveQuizStudentQuestionResults = /* GraphQL */ `
  query ListInteractiveQuizStudentQuestionResults(
    $filter: ModelInteractiveQuizStudentQuestionResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInteractiveQuizStudentQuestionResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quizInstanceId {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        questionId {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        userId {
          id
          first_name
          last_name
          mobile_no
          userType
          username
          createdAt
          updatedAt
          __typename
        }
        answerReceived
        pointsEarned
        createdAt
        updatedAt
        interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
        interactiveQuizQuestionsQuizStudentQuestionResultId
        interactiveQuizInstanceQuizStudentQuestionResultId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserConnections = /* GraphQL */ `
  query GetUserConnections($id: ID!) {
    getUserConnections(id: $id) {
      id
      userProfileDetailsId
      connectionId
      userProfileDetails {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      connection {
        id
        tag
        users {
          nextToken
          __typename
        }
        tags {
          id
          tag_name
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tagMasterTagConnectId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserConnections = /* GraphQL */ `
  query ListUserConnections(
    $filter: ModelUserConnectionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserConnections(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userProfileDetailsId
        connectionId
        userProfileDetails {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const RequestFromUserIndex = /* GraphQL */ `
  query RequestFromUserIndex(
    $from_user_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFriendRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    RequestFromUserIndex(
      from_user_id: $from_user_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        from_user_id
        to_user_id
        status
        accept_date
        decline_date
        connectionFriendID
        isAdminTriggered
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const RequestToUserIndex = /* GraphQL */ `
  query RequestToUserIndex(
    $to_user_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFriendRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    RequestToUserIndex(
      to_user_id: $to_user_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        from_user_id
        to_user_id
        status
        accept_date
        decline_date
        connectionFriendID
        isAdminTriggered
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const InviteToEmailIndex = /* GraphQL */ `
  query InviteToEmailIndex(
    $toEmail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInviteConnectionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    InviteToEmailIndex(
      toEmail: $toEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserId
        senderUserEmail
        senderUserName
        toEmail
        toName
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const UserActivityCartItemsIndex = /* GraphQL */ `
  query UserActivityCartItemsIndex(
    $cartItem_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserActivityCartItemsIndex(
      cartItem_id: $cartItem_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        from_user_id {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        to_user_id {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        cartItem_id
        status
        type
        data
        createdAt
        updatedAt
        userProfileDetailsUserActivityId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdIsMobileVerifiedIndex = /* GraphQL */ `
  query IdIsMobileVerifiedIndex(
    $isMobileVerified: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdIsMobileVerifiedIndex(
      isMobileVerified: $isMobileVerified
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdIsParentVerifiedIndex = /* GraphQL */ `
  query IdIsParentVerifiedIndex(
    $isParentVerified: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdIsParentVerifiedIndex(
      isParentVerified: $isParentVerified
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdIsSelfEmailVerifiedIndex = /* GraphQL */ `
  query IdIsSelfEmailVerifiedIndex(
    $isSelfEmailVerified: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdIsSelfEmailVerifiedIndex(
      isSelfEmailVerified: $isSelfEmailVerified
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdIsMinorIndex = /* GraphQL */ `
  query IdIsMinorIndex(
    $isMinor: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdIsMinorIndex(
      isMinor: $isMinor
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdIsDisabledIndex = /* GraphQL */ `
  query IdIsDisabledIndex(
    $isDisabled: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdIsDisabledIndex(
      isDisabled: $isDisabled
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdUserStatusIndex = /* GraphQL */ `
  query IdUserStatusIndex(
    $userStatus: String!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdUserStatusIndex(
      userStatus: $userStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanLoginIndex = /* GraphQL */ `
  query IdCanLoginIndex(
    $canLogin: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanLoginIndex(
      canLogin: $canLogin
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanViewSelfProfileIndex = /* GraphQL */ `
  query IdCanViewSelfProfileIndex(
    $canViewSelfProfile: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanViewSelfProfileIndex(
      canViewSelfProfile: $canViewSelfProfile
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanViewOthersProfileIndex = /* GraphQL */ `
  query IdCanViewOthersProfileIndex(
    $canViewOthersProfile: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanViewOthersProfileIndex(
      canViewOthersProfile: $canViewOthersProfile
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanEditSelfProfileIndex = /* GraphQL */ `
  query IdCanEditSelfProfileIndex(
    $canEditSelfProfile: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanEditSelfProfileIndex(
      canEditSelfProfile: $canEditSelfProfile
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanEditAccInfoIndex = /* GraphQL */ `
  query IdCanEditAccInfoIndex(
    $CanEditAccInfo: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanEditAccInfoIndex(
      CanEditAccInfo: $CanEditAccInfo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanAddMentorIndex = /* GraphQL */ `
  query IdCanAddMentorIndex(
    $canAddMentor: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanAddMentorIndex(
      canAddMentor: $canAddMentor
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanAddProjectsIndex = /* GraphQL */ `
  query IdCanAddProjectsIndex(
    $canAddProjects: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanAddProjectsIndex(
      canAddProjects: $canAddProjects
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanViewOtherProjectIndex = /* GraphQL */ `
  query IdCanViewOtherProjectIndex(
    $canViewOtherProject: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanViewOtherProjectIndex(
      canViewOtherProject: $canViewOtherProject
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanCreateCVIndex = /* GraphQL */ `
  query IdCanCreateCVIndex(
    $canCreateCV: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanCreateCVIndex(
      canCreateCV: $canCreateCV
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanShareCVIndex = /* GraphQL */ `
  query IdCanShareCVIndex(
    $canShareCV: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanShareCVIndex(
      canShareCV: $canShareCV
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const IdCanViewOtherCVIndex = /* GraphQL */ `
  query IdCanViewOtherCVIndex(
    $canViewOtherCV: Int!
    $sortDirection: ModelSortDirection
    $filter: ModeluserAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    IdCanViewOtherCVIndex(
      canViewOtherCV: $canViewOtherCV
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isMinor
        isDisabled
        userStatus
        userStatusLabel
        priority
        canLogin
        canViewSelfProfile
        canViewOthersProfile
        canEditSelfProfile
        CanEditAccInfo
        canAddMentor
        canAddProjects
        canViewOtherProject
        canCreateCV
        canShareCV
        canViewOtherCV
        canMakeConnections
        canSearchConnections
        canAddDairy
        canEditDairy
        canDeleteDairy
        canAddBlog
        canEditBlog
        canDeleteBlog
        canViewBlog
        enableMobileVerification
        enableParentalVerification
        enableSelfEmailVerification
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userConnectionsByUserProfileDetailsId = /* GraphQL */ `
  query UserConnectionsByUserProfileDetailsId(
    $userProfileDetailsId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserConnectionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userConnectionsByUserProfileDetailsId(
      userProfileDetailsId: $userProfileDetailsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userProfileDetailsId
        connectionId
        userProfileDetails {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        connection {
          id
          tag
          createdAt
          updatedAt
          tagMasterTagConnectId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userConnectionsByConnectionId = /* GraphQL */ `
  query UserConnectionsByConnectionId(
    $connectionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserConnectionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userConnectionsByConnectionId(
      connectionId: $connectionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userProfileDetailsId
        connectionId
        userProfileDetails {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          connectionsCount
          portfolioCount
          blogCount
          diaryCount
          cvCount
          mystuffCount
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getGroupSchool = /* GraphQL */ `
  query GetGroupSchool($id: ID!) {
    getGroupSchool(id: $id) {
      id
      name
      group_school_admin_email
      contact_number
      unique_code
      schools {
        nextToken
        __typename
      }
      schools_count
      logo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGroupSchools = /* GraphQL */ `
  query ListGroupSchools(
    $filter: ModelGroupSchoolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGroupSchools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools_count
        logo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchGroupSchools = /* GraphQL */ `
  query SearchGroupSchools(
    $filter: SearchableGroupSchoolFilterInput
    $sort: [SearchableGroupSchoolSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableGroupSchoolAggregationInput]
  ) {
    searchGroupSchools(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools_count
        logo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getChildSchool = /* GraphQL */ `
  query GetChildSchool($id: ID!) {
    getChildSchool(id: $id) {
      id
      name
      school_admin_email
      location
      board
      teachers
      group_school_unique_code
      group_school_id {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools {
          nextToken
          __typename
        }
        schools_count
        createdAt
        updatedAt
        __typename
      }
      package_selected
      unique_code
      current_academic_year_start
      current_academic_year_end
      academic_years_count
      teacher_count
      student_count
      course_count
      contact_number
      createdAt
      updatedAt
      groupSchoolSchoolsId
      __typename
    }
  }
`;
export const listChildSchools = /* GraphQL */ `
  query ListChildSchools(
    $filter: ModelChildSchoolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChildSchools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        school_admin_email
        location
        board
        teachers
        group_school_unique_code
        group_school_id {
          id
          name
          group_school_admin_email
          contact_number
          unique_code
          schools_count
          createdAt
          updatedAt
          __typename
        }
        package_selected
        unique_code
        current_academic_year_start
        current_academic_year_end
        academic_years_count
        teacher_count
        student_count
        course_count
        contact_number
        createdAt
        updatedAt
        groupSchoolSchoolsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchChildSchools = /* GraphQL */ `
  query SearchChildSchools(
    $filter: SearchableChildSchoolFilterInput
    $sort: [SearchableChildSchoolSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableChildSchoolAggregationInput]
  ) {
    searchChildSchools(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        school_admin_email
        location
        board
        teachers
        group_school_unique_code
        group_school_id {
          id
          name
          group_school_admin_email
          contact_number
          unique_code
          schools_count
          createdAt
          updatedAt
          __typename
        }
        package_selected
        unique_code
        current_academic_year_start
        current_academic_year_end
        academic_years_count
        teacher_count
        student_count
        course_count
        logo
        contact_number
        createdAt
        updatedAt
        groupSchoolSchoolsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSchoolCourses = /* GraphQL */ `
  query GetSchoolCourses($id: ID!) {
    getSchoolCourses(id: $id) {
      id
      moodle_course_id
      school_unique_id
      grade
      subject
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSchoolCourses = /* GraphQL */ `
  query ListSchoolCourses(
    $filter: ModelSchoolCoursesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchoolCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        moodle_course_id
        school_unique_id
        grade
        subject
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchSchoolCourses = /* GraphQL */ `
  query SearchSchoolCourses(
    $filter: SearchableSchoolCoursesFilterInput
    $sort: [SearchableSchoolCoursesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSchoolCoursesAggregationInput]
  ) {
    searchSchoolCourses(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        moodle_course_id
        school_unique_id
        grade
        subject
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCohort = /* GraphQL */ `
  query GetCohort($id: ID!) {
    getCohort(id: $id) {
      id
      name
      moodle_course_id
      students
      teacher_email
      moodle_cohort_id
      school_unique_id
      grade
      subject
      class
      subClass
      interest
      sub_interest
      current_academic_year_start
      current_academic_year_end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCohorts = /* GraphQL */ `
  query ListCohorts(
    $filter: ModelCohortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCohorts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        moodle_course_id
        students
        teacher_email
        moodle_cohort_id
        school_unique_id
        grade
        subject
        class
        subClass
        interest
        sub_interest
        current_academic_year_start
        current_academic_year_end
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCohorts = /* GraphQL */ `
  query SearchCohorts(
    $filter: SearchableCohortFilterInput
    $sort: [SearchableCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCohortAggregationInput]
  ) {
    searchCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        moodle_course_id
        students
        teacher_email
        moodle_cohort_id
        school_unique_id
        grade
        subject
        class
        subClass
        interest
        sub_interest
        current_academic_year_start
        current_academic_year_end
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAssessment = /* GraphQL */ `
  query GetAssessment($id: ID!) {
    getAssessment(id: $id) {
      id
      moodle_assessment_id
      moodle_master_course_id
      moodle_master_section_id
      moodle_master_fullcode
      assessment_name
      subject
      grade
      file_url
      url
      is_public
      is_disabled_by_super_admin
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAssessments = /* GraphQL */ `
  query ListAssessments(
    $filter: ModelAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssessments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAssessments = /* GraphQL */ `
  query SearchAssessments(
    $filter: SearchableAssessmentFilterInput
    $sort: [SearchableAssessmentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAssessmentAggregationInput]
  ) {
    searchAssessments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAssessmentInstance = /* GraphQL */ `
  query GetAssessmentInstance($id: ID!) {
    getAssessmentInstance(id: $id) {
      id
      start_time
      end_time
      cohort_id
      students
      teacher_email
      status
      term
      attempt_limit
      is_report_sent
      assessment_id {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      assessmentInstancesId
      __typename
    }
  }
`;
export const listAssessmentInstances = /* GraphQL */ `
  query ListAssessmentInstances(
    $filter: ModelAssessmentInstanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssessmentInstances(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        start_time
        end_time
        cohort_id
        students
        teacher_email
        status
        term
        attempt_limit
        is_report_sent
        createdAt
        updatedAt
        assessmentInstancesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAssessmentInstances = /* GraphQL */ `
  query SearchAssessmentInstances(
    $filter: SearchableAssessmentInstanceFilterInput
    $sort: [SearchableAssessmentInstanceSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAssessmentInstanceAggregationInput]
  ) {
    searchAssessmentInstances(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        assessment_id {
          id
          moodle_assessment_id
          moodle_master_course_id
          moodle_master_section_id
          moodle_master_fullcode
          assessment_name
          subject
          grade
          file_url
          url
          is_public
          is_disabled_by_super_admin
          createdAt
          updatedAt
          __typename
        }
        start_time
        end_time
        cohort_id
        students
        teacher_email
        status
        term
        attempt_limit
        is_report_sent
        createdAt
        updatedAt
        assessmentInstancesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAssessmentResponse = /* GraphQL */ `
  query GetAssessmentResponse($id: ID!) {
    getAssessmentResponse(id: $id) {
      id
      assessment_instance_id
      total_score
      result
      score
      student_id
      student_email
      student_name
      attempt_count
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAssessmentResponses = /* GraphQL */ `
  query ListAssessmentResponses(
    $filter: ModelAssessmentResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssessmentResponses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assessment_instance_id
        total_score
        result
        score
        student_id
        student_email
        student_name
        attempt_count
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAssessmentResponses = /* GraphQL */ `
  query SearchAssessmentResponses(
    $filter: SearchableAssessmentResponseFilterInput
    $sort: [SearchableAssessmentResponseSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAssessmentResponseAggregationInput]
  ) {
    searchAssessmentResponses(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        assessment_instance_id
        total_score
        result
        score
        student_id
        student_email
        student_name
        attempt_count
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSkills = /* GraphQL */ `
  query GetSkills($id: ID!) {
    getSkills(id: $id) {
      id
      name
      title
      description
      interest
      subinterest
      tag
      levels
      level_details
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSkills = /* GraphQL */ `
  query ListSkills(
    $filter: ModelSkillsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        title
        description
        interest
        subinterest
        tag
        levels
        level_details
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMasterSkill = /* GraphQL */ `
  query GetMasterSkill($id: ID!) {
    getMasterSkill(id: $id) {
      id
      name
      interest
      subinterest
      tag
      variants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMasterSkills = /* GraphQL */ `
  query ListMasterSkills(
    $filter: ModelMasterSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMasterSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        interest
        subinterest
        tag
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVariantSkill = /* GraphQL */ `
  query GetVariantSkill($id: ID!) {
    getVariantSkill(id: $id) {
      id
      variant_type
      variant_id
      variant_grade
      cohort_id
      name
      description
      level_count
      level_detail
      master_skill_id {
        id
        name
        interest
        subinterest
        tag
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      masterSkillVariantsId
      __typename
    }
  }
`;
export const listVariantSkills = /* GraphQL */ `
  query ListVariantSkills(
    $filter: ModelVariantSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVariantSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        variant_type
        variant_id
        variant_grade
        cohort_id
        name
        description
        level_count
        level_detail
        createdAt
        updatedAt
        masterSkillVariantsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchVariantSkills = /* GraphQL */ `
  query SearchVariantSkills(
    $filter: SearchableVariantSkillFilterInput
    $sort: [SearchableVariantSkillSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableVariantSkillAggregationInput]
  ) {
    searchVariantSkills(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        variant_type
        variant_id
        variant_grade
        cohort_id
        name
        description
        level_count
        level_detail
        createdAt
        updatedAt
        masterSkillVariantsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCompetitionCategory = /* GraphQL */ `
  query GetCompetitionCategory($id: ID!) {
    getCompetitionCategory(id: $id) {
      id
      code_type
      code_value
      category_name
      category_slug
      description
      start_date
      end_date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompetitionCategories = /* GraphQL */ `
  query ListCompetitionCategories(
    $filter: ModelCompetitionCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompetitionCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code_type
        code_value
        category_name
        category_slug
        description
        start_date
        end_date
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCompetitionCategories = /* GraphQL */ `
  query SearchCompetitionCategories(
    $filter: SearchableCompetitionCategoryFilterInput
    $sort: [SearchableCompetitionCategorySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompetitionCategoryAggregationInput]
  ) {
    searchCompetitionCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        code_type
        code_value
        category_name
        category_slug
        description
        start_date
        end_date
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCompetitionScore = /* GraphQL */ `
  query GetCompetitionScore($id: ID!) {
    getCompetitionScore(id: $id) {
      id
      competition_category_id
      score
      user_id
      post_id
      grader
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompetitionScores = /* GraphQL */ `
  query ListCompetitionScores(
    $filter: ModelCompetitionScoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompetitionScores(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        competition_category_id
        score
        user_id
        post_id
        grader
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCompetitionScores = /* GraphQL */ `
  query SearchCompetitionScores(
    $filter: SearchableCompetitionScoreFilterInput
    $sort: [SearchableCompetitionScoreSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompetitionScoreAggregationInput]
  ) {
    searchCompetitionScores(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        competition_category_id
        score
        user_id
        post_id
        grader
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPostCompetitionCategories = /* GraphQL */ `
  query GetPostCompetitionCategories($id: ID!) {
    getPostCompetitionCategories(id: $id) {
      id
      post_id
      is_graded
      competition_category_id
      competition_category_slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPostCompetitionCategories = /* GraphQL */ `
  query ListPostCompetitionCategories(
    $filter: ModelPostCompetitionCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPostCompetitionCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        post_id
        is_graded
        competition_category_id
        competition_category_slug
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchPostCompetitionCategories = /* GraphQL */ `
  query SearchPostCompetitionCategories(
    $filter: SearchablePostCompetitionCategoriesFilterInput
    $sort: [SearchablePostCompetitionCategoriesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchablePostCompetitionCategoriesAggregationInput]
  ) {
    searchPostCompetitionCategories(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        post_id
        is_graded
        competition_category_id
        competition_category_slug
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchAICardItems = /* GraphQL */ `
  query SearchAICardItems(
    $filter: SearchableAICardItemsFilterInput
    $sort: [SearchableAICardItemsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAICardItemsAggregationInput]
  ) {
    searchAICardItems(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        cardID
        data
        newdata
        prompt
        topic
        grade
        board
        language
        region
        count
        provider
        model
        chatHistroy
        pdfID
        generationConfig
        createdAt
        updatedAt
        cardUserAICardItemsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAICardItems = /* GraphQL */ `
  query GetAICardItems($id: ID!) {
    getAICardItems(id: $id) {
      id
      cardID
      data
      newdata
      prompt
      topic
      grade
      board
      language
      region
      count
      provider
      model
      userAICardItemsID {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      chatHistroy
      pdfID
      generationConfig
      createdAt
      updatedAt
      cardUserAICardItemsId
      __typename
    }
  }
`;
export const listAICardItems = /* GraphQL */ `
  query ListAICardItems(
    $filter: ModelAICardItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAICardItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cardID
        data
        newdata
        prompt
        topic
        grade
        board
        language
        region
        count
        provider
        model
        chatHistroy
        pdfID
        generationConfig
        createdAt
        updatedAt
        cardUserAICardItemsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUserAuthSessions = /* GraphQL */ `
  query SearchUserAuthSessions(
    $filter: SearchableUserAuthSessionFilterInput
    $sort: [SearchableUserAuthSessionSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAuthSessionAggregationInput]
  ) {
    searchUserAuthSessions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userProfileDetailsID
        loginExpireTime
        isValid
        loginAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserAuthSession = /* GraphQL */ `
  query GetUserAuthSession($id: ID!) {
    getUserAuthSession(id: $id) {
      id
      userProfileDetailsID
      loginExpireTime
      isValid
      loginAt
      instances {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserAuthSessions = /* GraphQL */ `
  query ListUserAuthSessions(
    $filter: ModelUserAuthSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAuthSessions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userProfileDetailsID
        loginExpireTime
        isValid
        loginAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUserAuthInstances = /* GraphQL */ `
  query SearchUserAuthInstances(
    $filter: SearchableUserAuthInstancesFilterInput
    $sort: [SearchableUserAuthInstancesSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAuthInstancesAggregationInput]
  ) {
    searchUserAuthInstances(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        key
        userProfileDetailsID
        aiCardItemID
        createdAt
        updatedAt
        userAuthSessionInstancesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserAuthInstances = /* GraphQL */ `
  query GetUserAuthInstances($id: ID!) {
    getUserAuthInstances(id: $id) {
      id
      key
      userProfileDetailsID
      userAuthSessionID {
        id
        userProfileDetailsID
        loginExpireTime
        isValid
        createdAt
        updatedAt
        __typename
      }
      aiCardItemID
      createdAt
      updatedAt
      userAuthSessionInstancesId
      __typename
    }
  }
`;
export const listUserAuthInstances = /* GraphQL */ `
  query ListUserAuthInstances(
    $filter: ModelUserAuthInstancesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAuthInstances(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        key
        userProfileDetailsID
        aiCardItemID
        createdAt
        updatedAt
        userAuthSessionInstancesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAIChat = /* GraphQL */ `
  query GetAIChat($id: ID!) {
    getAIChat(id: $id) {
      id
      userAuthSessionID
      userProfileDetailsID
      key
      topic
      config
      status
      aiMode
      currentQuestionIndex
      lastAccessedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAIChats = /* GraphQL */ `
  query ListAIChats(
    $filter: ModelAIChatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIChats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userAuthSessionID
        userProfileDetailsID
        key
        topic
        config
        status
        aiMode
        currentQuestionIndex
        lastAccessedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAIChats = /* GraphQL */ `
  query SearchAIChats(
    $filter: SearchableAIChatFilterInput
    $sort: [SearchableAIChatSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAIChatAggregationInput]
  ) {
    searchAIChats(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userAuthSessionID
        userProfileDetailsID
        key
        topic
        config
        status
        aiMode
        currentQuestionIndex
        lastAccessedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAIChatBlock = /* GraphQL */ `
  query GetAIChatBlock($id: ID!) {
    getAIChatBlock(id: $id) {
      id
      aiChatID
      type
      actor
      content
      createdAt
      questionIndex
      metadata
      updatedAt
      __typename
    }
  }
`;
export const listAIChatBlocks = /* GraphQL */ `
  query ListAIChatBlocks(
    $filter: ModelAIChatBlockFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIChatBlocks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        aiChatID
        type
        actor
        content
        createdAt
        questionIndex
        metadata
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAIChatBlocks = /* GraphQL */ `
  query SearchAIChatBlocks(
    $filter: SearchableAIChatBlockFilterInput
    $sort: [SearchableAIChatBlockSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAIChatBlockAggregationInput]
  ) {
    searchAIChatBlocks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        aiChatID
        type
        actor
        content
        createdAt
        questionIndex
        metadata
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserTopicXP = /* GraphQL */ `
  query GetUserTopicXP($id: ID!) {
    getUserTopicXP(id: $id) {
      id
      userProfileDetailsID
      topic
      totalXP
      questionCount
      level
      xpToReachNextLevel
      xpInLevel
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listUserTopicXPS = /* GraphQL */ `
  query ListUserTopicXPS(
    $filter: ModelUserTopicXPFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserTopicXPS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userProfileDetailsID
        topic
        totalXP
        questionCount
        level
        xpToReachNextLevel
        xpInLevel
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUserTopicXPS = /* GraphQL */ `
  query SearchUserTopicXPS(
    $filter: SearchableUserTopicXPFilterInput
    $sort: [SearchableUserTopicXPSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserTopicXPAggregationInput]
  ) {
    searchUserTopicXPS(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userProfileDetailsID
        topic
        totalXP
        questionCount
        level
        xpToReachNextLevel
        xpInLevel
        updatedAt
        createdAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSubject = /* GraphQL */ `
  query GetSubject($id: ID!) {
    getSubject(id: $id) {
      id
      name
      board
      grade
      revision
      description
      parts
      newData
      isCreatedBySchool
      moodleCourseID
      creatorEmail
      interestID
      subInterestID
      isDisabled
      creatorType
      isPublic
      schoolID
      skillID
      cardID
      cardItems
      subjectAssessments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubjects = /* GraphQL */ `
  query ListSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        board
        grade
        revision
        description
        parts
        newData
        isCreatedBySchool
        moodleCourseID
        creatorEmail
        interestID
        subInterestID
        isDisabled
        creatorType
        isPublic
        schoolID
        skillID
        cardID
        cardItems
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchSubjects = /* GraphQL */ `
  query SearchSubjects(
    $filter: SearchableSubjectFilterInput
    $sort: [SearchableSubjectSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSubjectAggregationInput]
  ) {
    searchSubjects(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        board
        grade
        revision
        description
        parts
        newData
        isCreatedBySchool
        moodleCourseID
        creatorEmail
        interestID
        subInterestID
        isDisabled
        creatorType
        isPublic
        schoolID
        skillID
        cardID
        cardItems
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSubjectAssessment = /* GraphQL */ `
  query GetSubjectAssessment($id: ID!) {
    getSubjectAssessment(id: $id) {
      id
      subjectID
      subject {
        id
        name
        board
        grade
        revision
        description
        parts
        newData
        isCreatedBySchool
        moodleCourseID
        creatorEmail
        interestID
        subInterestID
        isDisabled
        creatorType
        isPublic
        schoolID
        skillID
        cardID
        cardItems
        createdAt
        updatedAt
        __typename
      }
      createdBy
      cohortID
      name
      newData
      subjectCardID
      subjectCardItemID
      subjectAiCardItemID
      createdAt
      updatedAt
      subjectSubjectAssessmentsId
      __typename
    }
  }
`;
export const listSubjectAssessments = /* GraphQL */ `
  query ListSubjectAssessments(
    $filter: ModelSubjectAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectAssessments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subjectID
        createdBy
        cohortID
        name
        newData
        subjectCardID
        subjectCardItemID
        subjectAiCardItemID
        createdAt
        updatedAt
        subjectSubjectAssessmentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchSubjectAssessments = /* GraphQL */ `
  query SearchSubjectAssessments(
    $filter: SearchableSubjectAssessmentFilterInput
    $sort: [SearchableSubjectAssessmentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSubjectAssessmentAggregationInput]
  ) {
    searchSubjectAssessments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        subjectID
        createdBy
        cohortID
        name
        newData
        subjectCardID
        subjectCardItemID
        subjectAiCardItemID
        createdAt
        updatedAt
        subjectSubjectAssessmentsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getUserSystemAccessRole = /* GraphQL */ `
  query GetUserSystemAccessRole($id: ID!) {
    getUserSystemAccessRole(id: $id) {
      id
      name
      code
      description
      targetUserType
      aiFeatures
      moodleFeatures
      previews
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserSystemAccessRoles = /* GraphQL */ `
  query ListUserSystemAccessRoles(
    $filter: ModelUserSystemAccessRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSystemAccessRoles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        code
        description
        targetUserType
        aiFeatures
        moodleFeatures
        previews
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAIChildSchoolTeacher = /* GraphQL */ `
  query GetAIChildSchoolTeacher($id: ID!) {
    getAIChildSchoolTeacher(id: $id) {
      id
      teacherEmail
      teacherUserProfileDetailsID
      aiSchoolUniqueCode
      aiSchoolID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAIChildSchoolTeachers = /* GraphQL */ `
  query ListAIChildSchoolTeachers(
    $filter: ModelAIChildSchoolTeacherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIChildSchoolTeachers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherEmail
        teacherUserProfileDetailsID
        aiSchoolUniqueCode
        aiSchoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAIChildSchoolTeachers = /* GraphQL */ `
  query SearchAIChildSchoolTeachers(
    $filter: SearchableAIChildSchoolTeacherFilterInput
    $sort: [SearchableAIChildSchoolTeacherSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAIChildSchoolTeacherAggregationInput]
  ) {
    searchAIChildSchoolTeachers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        teacherEmail
        teacherUserProfileDetailsID
        aiSchoolUniqueCode
        aiSchoolID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getAIChildSchoolSubjectCohort = /* GraphQL */ `
  query GetAIChildSchoolSubjectCohort($id: ID!) {
    getAIChildSchoolSubjectCohort(id: $id) {
      id
      name
      teacherEmail
      teacherUserProfileDetailsID
      subjectID
      students
      aiSchoolUniqueCode
      aiSchoolID
      grade
      class
      subClass
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAIChildSchoolSubjectCohorts = /* GraphQL */ `
  query ListAIChildSchoolSubjectCohorts(
    $filter: ModelAIChildSchoolSubjectCohortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIChildSchoolSubjectCohorts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        teacherEmail
        teacherUserProfileDetailsID
        subjectID
        students
        aiSchoolUniqueCode
        aiSchoolID
        grade
        class
        subClass
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAIChildSchoolSubjectCohorts = /* GraphQL */ `
  query SearchAIChildSchoolSubjectCohorts(
    $filter: SearchableAIChildSchoolSubjectCohortFilterInput
    $sort: [SearchableAIChildSchoolSubjectCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAIChildSchoolSubjectCohortAggregationInput]
  ) {
    searchAIChildSchoolSubjectCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        teacherEmail
        teacherUserProfileDetailsID
        subjectID
        students
        aiSchoolUniqueCode
        aiSchoolID
        grade
        class
        subClass
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getGroupOrganization = /* GraphQL */ `
  query GetGroupOrganization($id: ID!) {
    getGroupOrganization(id: $id) {
      id
      name
      adminEmail
      adminContactNumber
      type
      logo
      isActive
      joinedAt
      childOrganizations {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGroupOrganizations = /* GraphQL */ `
  query ListGroupOrganizations(
    $filter: ModelGroupOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGroupOrganizations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        adminEmail
        adminContactNumber
        type
        logo
        isActive
        joinedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchGroupOrganizations = /* GraphQL */ `
  query SearchGroupOrganizations(
    $filter: SearchableGroupOrganizationFilterInput
    $sort: [SearchableGroupOrganizationSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableGroupOrganizationAggregationInput]
  ) {
    searchGroupOrganizations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        adminEmail
        adminContactNumber
        type
        logo
        isActive
        joinedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getChildOrganization = /* GraphQL */ `
  query GetChildOrganization($id: ID!) {
    getChildOrganization(id: $id) {
      id
      name
      groupOrganization {
        id
        name
        adminEmail
        adminContactNumber
        type
        logo
        isActive
        joinedAt
        createdAt
        updatedAt
        __typename
      }
      type
      image
      logo
      adminEmail
      adminContactNumber
      isActive
      joinedAt
      createdAt
      updatedAt
      groupOrganizationChildOrganizationsId
      __typename
    }
  }
`;
export const listChildOrganizations = /* GraphQL */ `
  query ListChildOrganizations(
    $filter: ModelChildOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChildOrganizations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        image
        logo
        adminEmail
        adminContactNumber
        isActive
        joinedAt
        createdAt
        updatedAt
        groupOrganizationChildOrganizationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchChildOrganizations = /* GraphQL */ `
  query SearchChildOrganizations(
    $filter: SearchableChildOrganizationFilterInput
    $sort: [SearchableChildOrganizationSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableChildOrganizationAggregationInput]
  ) {
    searchChildOrganizations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        type
        image
        logo
        adminEmail
        adminContactNumber
        isActive
        joinedAt
        createdAt
        updatedAt
        groupOrganizationChildOrganizationsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOrganizationCohort = /* GraphQL */ `
  query GetOrganizationCohort($id: ID!) {
    getOrganizationCohort(id: $id) {
      id
      name
      ContentID
      description
      instructorID
      groupOrganizationID
      childOrganizationID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizationCohorts = /* GraphQL */ `
  query ListOrganizationCohorts(
    $filter: ModelOrganizationCohortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationCohorts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        ContentID
        description
        instructorID
        groupOrganizationID
        childOrganizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchOrganizationCohorts = /* GraphQL */ `
  query SearchOrganizationCohorts(
    $filter: SearchableOrganizationCohortFilterInput
    $sort: [SearchableOrganizationCohortSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrganizationCohortAggregationInput]
  ) {
    searchOrganizationCohorts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        ContentID
        description
        instructorID
        groupOrganizationID
        childOrganizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOrganizationCohortMember = /* GraphQL */ `
  query GetOrganizationCohortMember($id: ID!) {
    getOrganizationCohortMember(id: $id) {
      id
      userProfileDetailsID
      organizationCohortID
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizationCohortMembers = /* GraphQL */ `
  query ListOrganizationCohortMembers(
    $filter: ModelOrganizationCohortMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationCohortMembers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userProfileDetailsID
        organizationCohortID
        role
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchOrganizationCohortMembers = /* GraphQL */ `
  query SearchOrganizationCohortMembers(
    $filter: SearchableOrganizationCohortMemberFilterInput
    $sort: [SearchableOrganizationCohortMemberSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrganizationCohortMemberAggregationInput]
  ) {
    searchOrganizationCohortMembers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userProfileDetailsID
        organizationCohortID
        role
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getContent = /* GraphQL */ `
  query GetContent($id: ID!) {
    getContent(id: $id) {
      id
      title
      description
      type
      data
      isPublic
      uploadedBy
      uploadedByUserType
      publishedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listContents = /* GraphQL */ `
  query ListContents(
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        type
        data
        isPublic
        uploadedBy
        uploadedByUserType
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchContents = /* GraphQL */ `
  query SearchContents(
    $filter: SearchableContentFilterInput
    $sort: [SearchableContentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableContentAggregationInput]
  ) {
    searchContents(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title
        description
        type
        data
        isPublic
        uploadedBy
        uploadedByUserType
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOrganizationCohortAssessment = /* GraphQL */ `
  query GetOrganizationCohortAssessment($id: ID!) {
    getOrganizationCohortAssessment(id: $id) {
      id
      groupOrganizationID
      childOrganizationID
      organizationCohortID
      name
      description
      questionsCount
      totalMarks
      duration
      passingMarks
      fileDetails
      type
      isDirectUpload
      uploadedBy
      uploadedByUserOrgRole
      AiCardItemDetails
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizationCohortAssessments = /* GraphQL */ `
  query ListOrganizationCohortAssessments(
    $filter: ModelOrganizationCohortAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationCohortAssessments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupOrganizationID
        childOrganizationID
        organizationCohortID
        name
        description
        questionsCount
        totalMarks
        duration
        passingMarks
        fileDetails
        type
        isDirectUpload
        uploadedBy
        uploadedByUserOrgRole
        AiCardItemDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchOrganizationCohortAssessments = /* GraphQL */ `
  query SearchOrganizationCohortAssessments(
    $filter: SearchableOrganizationCohortAssessmentFilterInput
    $sort: [SearchableOrganizationCohortAssessmentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrganizationCohortAssessmentAggregationInput]
  ) {
    searchOrganizationCohortAssessments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        groupOrganizationID
        childOrganizationID
        organizationCohortID
        name
        description
        questionsCount
        totalMarks
        duration
        passingMarks
        fileDetails
        type
        isDirectUpload
        uploadedBy
        uploadedByUserOrgRole
        AiCardItemDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const organizationCohortAssessmentsByGroupOrganizationID = /* GraphQL */ `
  query OrganizationCohortAssessmentsByGroupOrganizationID(
    $groupOrganizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationCohortAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationCohortAssessmentsByGroupOrganizationID(
      groupOrganizationID: $groupOrganizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupOrganizationID
        childOrganizationID
        organizationCohortID
        name
        description
        questionsCount
        totalMarks
        duration
        passingMarks
        fileDetails
        type
        isDirectUpload
        uploadedBy
        uploadedByUserOrgRole
        AiCardItemDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const organizationCohortAssessmentsByChildOrganizationID = /* GraphQL */ `
  query OrganizationCohortAssessmentsByChildOrganizationID(
    $childOrganizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationCohortAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationCohortAssessmentsByChildOrganizationID(
      childOrganizationID: $childOrganizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupOrganizationID
        childOrganizationID
        organizationCohortID
        name
        description
        questionsCount
        totalMarks
        duration
        passingMarks
        fileDetails
        type
        isDirectUpload
        uploadedBy
        uploadedByUserOrgRole
        AiCardItemDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const organizationCohortAssessmentsByOrganizationCohortID = /* GraphQL */ `
  query OrganizationCohortAssessmentsByOrganizationCohortID(
    $organizationCohortID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationCohortAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationCohortAssessmentsByOrganizationCohortID(
      organizationCohortID: $organizationCohortID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupOrganizationID
        childOrganizationID
        organizationCohortID
        name
        description
        questionsCount
        totalMarks
        duration
        passingMarks
        fileDetails
        type
        isDirectUpload
        uploadedBy
        uploadedByUserOrgRole
        AiCardItemDetails
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompetition = /* GraphQL */ `
  query GetCompetition($id: ID!) {
    getCompetition(id: $id) {
      id
      name
      description
      theme
      location
      coverImage
      isOnline
      isPrivate
      isMoodleBased
      moodleCourseId
      redirectLink
      startDate
      endDate
      registrationStart
      registrationEnd
      status
      criteria
      minTeamSize
      maxTeamSize
      participantCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompetitions = /* GraphQL */ `
  query ListCompetitions(
    $filter: ModelCompetitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompetitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        theme
        location
        coverImage
        isOnline
        isPrivate
        isMoodleBased
        moodleCourseId
        redirectLink
        startDate
        endDate
        registrationStart
        registrationEnd
        status
        criteria
        minTeamSize
        maxTeamSize
        participantCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCompetitions = /* GraphQL */ `
  query SearchCompetitions(
    $filter: SearchableCompetitionFilterInput
    $sort: [SearchableCompetitionSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompetitionAggregationInput]
  ) {
    searchCompetitions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        description
        theme
        location
        coverImage
        isOnline
        isPrivate
        isMoodleBased
        moodleCourseId
        redirectLink
        startDate
        endDate
        registrationStart
        registrationEnd
        status
        criteria
        minTeamSize
        maxTeamSize
        participantCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getParticipant = /* GraphQL */ `
  query GetParticipant($id: ID!) {
    getParticipant(id: $id) {
      id
      competitionId
      userId
      email
      firstName
      lastName
      teamId
      teamName
      isLeader
      registeredAt
      score
      rank
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listParticipants = /* GraphQL */ `
  query ListParticipants(
    $filter: ModelParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listParticipants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        competitionId
        userId
        email
        firstName
        lastName
        teamId
        teamName
        isLeader
        registeredAt
        score
        rank
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchParticipants = /* GraphQL */ `
  query SearchParticipants(
    $filter: SearchableParticipantFilterInput
    $sort: [SearchableParticipantSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableParticipantAggregationInput]
  ) {
    searchParticipants(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        competitionId
        userId
        email
        firstName
        lastName
        teamId
        teamName
        isLeader
        registeredAt
        score
        rank
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPublisher = /* GraphQL */ `
  query GetPublisher($id: ID!) {
    getPublisher(id: $id) {
      id
      userProfileDetailsID
      userMasterDetailsID
      firstName
      lastName
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPublishers = /* GraphQL */ `
  query ListPublishers(
    $filter: ModelPublisherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPublishers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userProfileDetailsID
        userMasterDetailsID
        firstName
        lastName
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchPublishers = /* GraphQL */ `
  query SearchPublishers(
    $filter: SearchablePublisherFilterInput
    $sort: [SearchablePublisherSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchablePublisherAggregationInput]
  ) {
    searchPublishers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        userProfileDetailsID
        userMasterDetailsID
        firstName
        lastName
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPublisherBook = /* GraphQL */ `
  query GetPublisherBook($id: ID!) {
    getPublisherBook(id: $id) {
      id
      publisherID
      title
      subject
      grade
      board
      language
      authors
      licenceKey
      data
      description
      coverImage
      bookFile
      publishedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPublisherBooks = /* GraphQL */ `
  query ListPublisherBooks(
    $filter: ModelPublisherBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPublisherBooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        publisherID
        title
        subject
        grade
        board
        language
        authors
        licenceKey
        data
        description
        coverImage
        bookFile
        publishedAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchPublisherBooks = /* GraphQL */ `
  query SearchPublisherBooks(
    $filter: SearchablePublisherBookFilterInput
    $sort: [SearchablePublisherBookSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchablePublisherBookAggregationInput]
  ) {
    searchPublisherBooks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        publisherID
        title
        subject
        grade
        board
        language
        authors
        licenceKey
        data
        description
        coverImage
        bookFile
        publishedAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;